module.exports = __webpack_public_path__ + "img/mirta.3a86920f.png";